import Button from './Button';

export { default as ButtonLink } from './ButtonLink';
export default Button;



// WEBPACK FOOTER //
// ./src/@ui/Button/index.js